import { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Grid, IconButton, Typography } from "@mui/material";
import { IDocChange } from "./HistoryWindow";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { openHistoryWindow } from "src/redux/actions/Mosaic.Actions";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useDispatch } from "react-redux";

interface IViewHistoryProps {
  path: string[];
  id: string;
  collection: string;
}

export const ViewHistoryCell = (props: IViewHistoryProps): JSX.Element => {
  const { path, id, collection } = props;
  const dispatch = useDispatch();
  return (
    <IconButton
      style={{ width: 40, height: 40 }}
      id="popout_summary_btn"
      onClick={() => {
        dispatch(openHistoryWindow(`${collection} History`, { collection, id }, path));
      }}
    >
      <OpenInNewIcon />
    </IconButton>
  );
};

interface IHistoryProps {
  data: IDocChange;
}
//This would be a value for a column
export const HistoryTableComponentCell = (props: IHistoryProps): JSX.Element => {
  const { data } = props;
  const [expanded, setExpanded] = useState<boolean>(false);
  return (
    <Grid container direction="column" className="history_cell">
      <Accordion
        classes={{ root: "history_cell_accordion" }}
        expanded={expanded}
        // key={historyIndex}
        onChange={() => {
          setExpanded(!expanded);
        }}
      >
        <AccordionSummary classes={{ root: "history_cell_accordion_summary" }} expandIcon={<ExpandMoreIcon />}>
          <Grid container className="update_type">
            <Typography classes={{ body1: "update_type_font" }}>Changes</Typography>
          </Grid>
        </AccordionSummary>
        <AccordionDetails className="history_details">
          {data.fieldsAdded.length > 0 && (
            <Grid item className="field_update_type">
              <Typography classes={{ body1: "update_type_font" }}>Fields Added</Typography>
            </Grid>
          )}
          {data.fieldsAdded.map((addedField: any, index: number) => (
            <DisplayField
              key={`add_${index}`}
              field={addedField.key}
              prevValue={null}
              modifiedValue={addedField.value}
            />
          ))}
          {data.fieldsChanged.length > 0 && (
            <Grid item className="field_update_type">
              <Typography classes={{ body1: "update_type_font" }}>Fields Modified</Typography>
            </Grid>
          )}
          {data.fieldsChanged.map((changedItem: any, index: number) => (
            <DisplayField
              key={`change_${index}`}
              field={changedItem.key}
              modifiedValue={changedItem.value.new}
              prevValue={changedItem.value.prev}
            />
          ))}
          {data.fieldsRemoved.length > 0 && (
            <Grid item className="field_update_type">
              <Typography classes={{ body1: "update_type_font" }}>Fields Removed</Typography>
            </Grid>
          )}
          {data.fieldsRemoved.map((removedField: any, index: number) => (
            <DisplayField
              key={`remove_${index}`}
              field={removedField.key}
              prevValue={removedField.value}
              modifiedValue={null}
            />
          ))}
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

interface IDisplayFieldProps {
  field: string;
  modifiedValue: any;
  prevValue?: any;
}

export const DisplayField = (props: IDisplayFieldProps): JSX.Element => {
  const { field, modifiedValue, prevValue } = props;
  return (
    <Grid container justifyContent="space-between" className="history_item">
      <Grid item className="field">
        {field}:{" "}
      </Grid>

      <Grid item className="modified">
        {typeof prevValue === "string" || typeof prevValue === "number"
          ? prevValue
          : typeof prevValue === "boolean"
            ? prevValue?.toString()
            : prevValue === null || !prevValue
              ? "null"
              : Array.isArray(prevValue) && !prevValue.length
                ? "[ ]"
                : "object"}
      </Grid>

      <Grid item className="added">
        {typeof modifiedValue === "string" ||
        typeof modifiedValue === "number" ||
        modifiedValue === null ||
        Array.isArray(modifiedValue)
          ? modifiedValue
          : typeof modifiedValue === "boolean"
            ? modifiedValue?.toString()
            : modifiedValue === null || !modifiedValue
              ? "null"
              : Array.isArray(modifiedValue) && !modifiedValue.length
                ? "[ ]"
                : "object"}
      </Grid>
    </Grid>
  );
};
